<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100" [ngClass.sm]="'text-right'">
                <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'">
                    <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate"
                           class="form-control" [ngClass.xl]="'w-fit d-inline-block'" [ngClass.md]="'w-fit d-inline-block'" [ngClass.sm]="'mb-075'"
                           [(ngModel)]="searchKeyword"/>
                    <select [(ngModel)]="searchStatus" class="form-control" [ngClass.xl]="'w-fit d-inline-block ml-1'" [ngClass.md]="'w-fit d-inline-block ml-1'"
                            [ngClass.sm]="'mb-075'">
                        <option value="2">{{"ALL_FEMALE_PLURAL" | translate}}</option>
                        <option value="-1">{{"TO_APPROVED" | translate}}</option>
                        <!--<option value="0">{{"DEACTIVATE" | translate}}</option>-->
                    </select>
                    <a (click)="modalOpen(certificationAdd, null)" class="btn btn-outline-primary text-primary"
                       *ngIf="_utilService.isMobile && _authenticationService.hasCapability('create_certification')">{{'ADD' | translate}}</a>
                </div>
                <div class="float-right" [ngClass.sm]="'d-none'">
                    <div class="d-inline-block mr-2">
                        <label class="d-flex align-items-center">{{"SHOW" | translate}}
                            <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                    </div>

                    <a (click)="modalOpen(certificationAdd, null)" class="btn btn-outline-primary text-primary"
                       *ngIf="_authenticationService.hasCapability('create_certification')">{{'ADD' | translate}}</a>
                </div>
                <div class="clearboth"></div>
            </div>

            <!--Desktop-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [footerHeight]="config.footerHeight" [rows]="certificationsList()">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [sortable]="col.sortable || false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row[col.value] }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false" width="200">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center">
                                <button (click)="modalOpen(certificationEdit, row)"
                                        class="bg-transparent border-0 text-secondary pr-1"
                                        *ngIf="_authenticationService.hasCapability('edit_certification')">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                                <button (click)="deleteCertification(row)"
                                        class="bg-transparent border-0 text-danger remove-item"
                                        *ngIf="_authenticationService.hasCapability('delete_certification')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                                <div *ngIf="row.enabled===-1 && _authenticationService.hasCapability('edit_certification')">
                                    <button (click)="approve(row.id)"
                                            class="btn btn-outline-primary ml-1 btn-sm">{{"APPROVE" | translate}}</button>
                                    <button (click)="reject(row.id)"
                                            class="btn btn-outline-secondary ml-1 btn-sm">{{"REJECT" | translate}}</button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--Mobile - tablet-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [scrollbarH]="false" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [footerHeight]="config.footerHeight" [rows]="certificationsList()">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [width]="col.width || null"
                                          [sortable]="col.sortable || false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12">
                                    <span class="text-break-line-1">{{ row[col.value] }}</span>
                                </div>
                                <div class="col-12 mt-075 align-items-center">
                                    <div class="d-flex align-items-center">
                                        <button (click)="modalOpen(certificationEdit, row)"
                                                class="bg-transparent border-0 text-secondary pr-1"
                                                *ngIf="_authenticationService.hasCapability('edit_certification')">
                                            <i [data-feather]="'edit-2'" size="19"></i>
                                        </button>
                                        <button (click)="deleteCertification(row)"
                                                class="bg-transparent border-0 text-danger remove-item"
                                                *ngIf="_authenticationService.hasCapability('delete_certification')">
                                            <i [data-feather]="'trash-2'" size="19"></i>
                                        </button>
                                        <div *ngIf="row.enabled===-1 && _authenticationService.hasCapability('edit_certification')">
                                            <button (click)="approve(row.id)"
                                                    class="btn btn-outline-primary ml-1 btn-sm">{{"APPROVE" | translate}}</button>
                                            <button (click)="reject(row.id)"
                                                    class="btn btn-outline-secondary ml-1 btn-sm">{{"REJECT" | translate}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>

<!-- Modal Add -->
<ng-template #certificationAdd let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"ERRORS.ADD_NEW_CERTIFICATE" | translate}}</h3>
        <label [for]="'new_certification'">{{'CERTIFICATE' | translate}}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="new_certification" name="new_certification" type="text" [id]="'new_certification'"
               class="form-control"/>
        <div class="font-error" *ngIf="showModalError">{{ 'ERRORS.FIELD_CERTIFICATION' | translate }}</div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()">
            {{"CANCEL" | translate}}
        </button>
        <button type="button" class="btn btn-primary w-150" (click)="addCertification()">
            {{"SEND" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #certificationEdit let-modal>
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modal.close()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"EDIT" | translate}} {{"CERTIFICATE" | translate}}</h3>
            <label [for]="'certificate'">{{'CERTIFICATE' | translate}}<sup class="text-danger">*</sup></label>
            <input name="currentCertificateName" [(ngModel)]="currentCertification.name" type="text" [id]="'certificate'" class="form-control"/>
            <div class="font-error" *ngIf="currentCertification.name.length < 1">{{ 'ERRORS.FIELD_CERTIFICATION' | translate }}</div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary" (click)="modal.close()">
                {{"CANCEL" | translate}}
            </button>
            <button type="button" class="btn btn-primary w-150" (click)="editCertification()">
                {{"EDIT" | translate}}
            </button>
        </div>
</ng-template>
<!-- / Modal Edit -->